import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

export const styles = StyleSheet.create({
    container: {
        marginLeft: Theme.primaryMargin,
        marginRight: Theme.primaryMargin
    },
    itemDivider: {
        marginTop: 30,
        marginBottom: Device.isTablet ? null : 15,
        backgroundColor: '#A4A4A4',
        opacity: 1,
        height: 1
    }
});
